<template>
  <div class="modal">
    <div class="modal__header">
      <div class="modal__header__title">
        <slot name="title"></slot>
      </div>
    </div>
    <div class="modal__content">
      <slot name="content"></slot>
    </div>
    <div class="modal__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__header {
    height: 6rem;
    border-bottom: 0.1rem solid $border-color;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: 700;
    color: $dark;
  }

  &__content {
    width: 100%;
    flex-grow: 1;
  }

  &__footer {
    display: flex;
    height: 6rem;
    border-top: 0.1rem solid $border-color;
    justify-content: stretch;
  }

  &-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.3rem;
    font-weight: 600;
    color: $grey;
    transition: all 0.3s;
  }
}
</style>
